namespace AgerLMS {
    export enum SlideTypes {
        Type1 = 0,
        Type2 = 1,
        Type3 = 2
    }
    Serenity.Decorators.registerEnumType(SlideTypes, 'AgerLMS.SlideTypes');
}
